import { render, staticRenderFns } from "./Linkman.vue?vue&type=template&id=1aae5e83&scoped=true&"
import script from "./Linkman.vue?vue&type=script&lang=js&"
export * from "./Linkman.vue?vue&type=script&lang=js&"
import style0 from "./Linkman.vue?vue&type=style&index=0&id=1aae5e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae5e83",
  null
  
)

export default component.exports